import { __assign, __rest } from "tslib";
import Message from '@concur/react-message-formatter';
import React, { forwardRef } from 'react';
import useIntl from '../useIntl';
/**
 * React component to format a message
 */
function FormatMessage(props, ref) {
    var _a;
    var id = props.id, elementId = props.elementId, values = props.values, _b = props.element, element = _b === void 0 ? 'span' : _b, others = __rest(props, ["id", "elementId", "values", "element"]);
    var _c = useIntl(), formatMessage = _c.formatMessage, formatMessageToParts = _c.formatMessageToParts;
    var getMessage = function (id, values) { return formatMessage({ id: id, values: values }); };
    var attributes = __assign(__assign({}, others), { ref: ref, id: elementId, 'data-trans-id': id, 'data-trans-legacyid': (_a = formatMessageToParts(id)['legacyId']) !== null && _a !== void 0 ? _a : '' });
    return React.createElement(element, attributes, React.createElement(Message, { getMessage: getMessage, id: id, values: values }));
}
export default forwardRef(FormatMessage);
